// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GreetingCard_wrapper__gcBUf","grid":"GreetingCard_grid__8lyWf","grid__row":"GreetingCard_grid__row__mwZIA","grid__column":"GreetingCard_grid__column__8ibsO"};